import { TARGET_TYPE, JOIN_STATUS, DEMAND_TYPE, YU_SUAN } from 'pages/manage/orderSquare/constants/index';

// 批量数字类型检验
// const ID_RULES = [
//   {
//     pattern: numArray,
//     message: '请输入数字',
//   },
// ];

export default (props) => {
  // const { csIndustryTree, appTypeOptions } = props;
  const { csIndustryTree } = props;
  return {
    controls: [
      // {
      //   name: 'timeRange',
      //   title: '时间',
      //   type: 'date-picker',
      //   defaultValue: {
      //     start_time: dayjs().date(1)
      //       .format('YYYY-MM-DD'),
      //     end_time: dayjs().subtract(0, 'day')
      //       .format('YYYY-MM-DD'),
      //   },
      //   config: {
      //     useShortcut: true,
      //     format: 'xxxx-xx-xx',
      //     shortcuts: [
      //       { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
      //       { startRelativeDate: 0 - 6 - dayjs().day(), endRelativeDate: 0 - dayjs().day(), label: '上一周' },
      //     ],
      //     optionalStartDate: dayjs().date(1)
      //       .month(0)
      //       .year(dayjs().get('year') - 1)
      //       .format('YYYY-MM-DD'),
      //     optionalEndDate: dayjs().subtract(-1, 'day')
      //       .format('YYYY-MM-DD'),
      //   },
      // },
      {
        name: 'target',
        title: '需求目标',
        type: 'select',
        config: {
          multiple: true,
          search: false,
          data: TARGET_TYPE,
          placeholder: '请选择需求目标',
        },
      },
      {
        name: 'type',
        title: '需求类型',
        type: 'select',
        config: {
          multiple: true,
          search: false,
          data: DEMAND_TYPE,
          placeholder: '请选择需求类型',
        },
      },
      {
        name: 'tenderStatus',
        title: '参与状态',
        type: 'select',
        config: {
          multiple: true,
          search: false,
          data: JOIN_STATUS,
          placeholder: '请选择参与状态',
        },
      },
      // {
      //   name: 'appType',
      //   title: '服务类型',
      //   type: 'select',
      //   config: {
      //     multiple: true,
      //     search: false,
      //     data: appTypeOptions,
      //     placeholder: '请选择服务类型',
      //   },
      // },
      {
        name: 'companyIndustry',
        title: '所在行业',
        type: 'select',
        config: {
          multiple: true,
          search: false,
          data: csIndustryTree,
          placeholder: '请选择所在行业',
        },
      },
      {
        name: 'yusuan',
        title: '客户预算',
        type: 'select',
        config: {
          multiple: true,
          search: false,
          data: YU_SUAN,
        },
      },
    ],
  };
};
